module.exports = __webpack_public_path__ + "fonts/Didot-Italic.39299595.ttf";